import { DynasetSymbol } from './dynaset';
import * as process from 'process';

export const HOMEPAGE_CONTENT = {
  HOME: {
    title: `AI Powered DeFi`,
    title1: `singularity`,
    title2: `dao`,

    description: 'Redefining',
    description1: 'Crypto',
    description2: 'Asset Management',
    metaDescription: 'Smart Money, On-Chain',
  },
  HOME_CARD: {
    name: 'Total Value Locked on the SingularityDAO Protocol',
    description:
      'SingularityDAO is a decentralised Portfolio Management Protocol designed to enable anybody to safely and easily manage crypto assets, supported by superior risk management and analytics tools; smart money, on-chain.',
    metaDescription:
      'A non-custodial protocol built to foster a new ecosystem of Digital Asset Managers to offer automated trading strategies leveraging AI-enhanced data analytics services.',
  },
  DYNASETS: {
    name: 'DynaSets',
    description:
      'DynaSets are bringing the sophisticated risk-management strategies of AI-powered portfolio management to DeFi, using advanced data science backed strategies developed in-house by a world class team of quant analysts, to dynamically rebalance and optimise sets of tokens.',
    description2:
      'SingularityDAO’s Dynamic Asset Manager (DAM) is authorised to manage the ratio of assets held within the DynaSet via trustless smart contracts.',
    route: {
      [DynasetSymbol.dynBTC]: `/dynasets/${DynasetSymbol.dynBTC}`,
      [DynasetSymbol.dynETH]: `dynasets/${DynasetSymbol.dynETH}`,
      [DynasetSymbol.dynDYDX]: `/dynalab/${DynasetSymbol.dynDYDX}`,
    },
  },
  VAULTS: {
    name: 'Vaults',
    description:
      'Vaults enable users to receive rewards by either staking or farming participating tokens. Lock your tokens in SingularityDAO’s Epoch Vaults for longer periods of time for the best results.',
    image: '',
    button: 'Explore Vaults',
    route: '/vaults/unbondedvaults',
  },
  LAUNCHPAD: {
    name: 'LaunchPad',
    description:
      'The SingularityDAO Launchpad is the place to gain access to all the new SingularityNET Ecosystem launches as well as many other interesting projects. Become a DAO participant to receive guaranteed allocations.',
    button: 'Explore LaunchPad',
    route: '/launchpad/myallocations',
    image: '',
  },
  AI: {
    name: 'Artificial Intelligence',
    description:
      'The SingularityDAO research team is made up of world class AI scientists, data engineers and quant strategists. Leveraging Machine Learning and Neural Networks to create strategies, signals and automated trading algorithms.',
    button: 'Research Papers',
    route:
      'https://docs.singularitydao.ai/research-papers/artificial-intelligence',

    image: '',
  },
  DAO: {
    name: 'DAO',
    description:
      'The DAO consists of a governance structure that will offer both voting power and a reputation system granted to its participants. The SDAO Token will play a crucial role as the governance token of the DAO. There will be a multi-tiered reward system encouraging participants to unite and grow as a community.',
    image: '',
    button: 'Soon',
  },
};

export const PANEL_TYPE: {
  [key: string]: string;
} = {
  WITHDRAW: 'Withdraw',
  HARVEST: 'Harvest',
  WITHDRAWHARVEST: 'Withdraw + Harvest',
  STARTFARMING: 'Farm',
  STAKE: 'Stake',
  CLAIM: 'Claim',
  APPROVE: 'Approve',
  CLOSE: 'Close',
  DEPOSIT: 'Deposit',
  ADD_LIQUIDITY: 'ADD_LIQUIDITY',
  WITHDRAW_LIQUIDITY: 'REMOVE_LIQUIDITY',
  FARM: 'Farm',
  STAKE_CLOSED: 'Stake Closed',
  OK: 'Ok',
  DEPOSIT_LAUNCHPAD: 'Deposit launchpad',
  CLAIM_LAUNCHPAD: 'Claim',
};

export const VAULT_TYPE = {
  FARM: 'Yield Farm',
  UNBONDED: 'Unbonded',
  BONDED: 'Epoch Vault',
};

export const DEFAULT_CARD_WIDTH = 348;
export const DEFAULT_CARD_WIDTH_CLASS = 'w-80';

export const TOAST_OPTIONS = {
  success: 'success',
  error: 'error',
  info: 'info',
  warnnig: 'warnnig',
};

export const TOAST_CONFIG: {
  [key: string]: string | number | boolean;
} = {
  position: 'top-right',
  autoClose: 8000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  newestOnTop: false,
};

export const CONVERSION_TYPES = { FROM: 'FROM', TO: 'TO' };

export const LINEGRAPH_HOME_SNAPSHOTS = 10;

export const DEFAULT_PRECISION = 6;

export const DEFAULT_PRECISION_EPOCH_UNBONDED = 2;

export const DEFAULT_APY_DECIMALS = 2;

export const DE_FI = {
  PANCAKESWAP: 'Pancakeswap',
  UNISWAP: 'Uniswap',
};

/*
Note: Default values for production only
Production and Staging environments use the original host:
singularitydao.ai, dapp.singularitydao.ai, dapp.dev.singularitydao.ai

For local development, override NEXT_PUBLIC_API_HOST and NEXT_PUBLIC_API_PREFIX.
NEXT_PUBLIC_API_HOST=https://onchain-server.dev.singularitydao.ai
NEXT_PUBLIC_API_PREFIX=/dynaset-server/api
*/
const API_HOST =
  process.env.NEXT_PUBLIC_API_HOST ||
  'https://onchain-server.dev.singularitydao.ai';
const API_PATH_PREFIX =
  process.env.NEXT_PUBLIC_API_PREFIX || '/dynaset-server/api';
export const ONCHAIN_SERVER = API_HOST + API_PATH_PREFIX;

const LAUNCHPAD_API_HOST = process.env.NEXT_PUBLIC_API_LAUNCHPAD_HOST || '';
const API_LAUNCHPAD_PREFIX =
  process.env.NEXT_PUBLIC_API_LAUNCHPAD_PREFIX || '/api/launchpad';
export const API_LAUNCHPAD_BASE_URL = LAUNCHPAD_API_HOST + API_LAUNCHPAD_PREFIX;
export const API_DYNASET_BASE_URL = API_HOST + API_PATH_PREFIX;
export const USER_SVC_BASE_URL = process.env.NEXT_PUBLIC_USERS_SVC || '';
export const DAPP_BACKEND_BASE_URL = process.env.NEXT_PUBLIC_DAPP_BACKEND;

export const API_STAKING_BASE_URL =
  process.env.NEXT_PUBLIC_API_STAKING_HOST ||
  'https://staking-service.dev.singularitydao.ai';
export const API_STAKING_TESTNET_BASE_URL =
  process.env.NEXT_PUBLIC_API_STAKING_TESTNET_HOST ||
  'https://staking-service.dev.singularityfinance.ai';
export const SFI_BACKEND_BASE_URL = process.env.NEXT_PUBLIC_SFI_BACKEND_SVC;
export const API_DYNAVAULTS_BASE_URL =
  process.env.NEXT_PUBLIC_API_DYNAVAULTS_HOST || '';
export const TOTAL_VALUE_LOCKED_ENDPOINT = `${ONCHAIN_SERVER}/tvl/getTvl`;
export const TOTAL_VALUE_LOCKED_FORGE_ENDPOINT = `${ONCHAIN_SERVER}/forge/getTvl`;
export const TOTAL_SDAO_LOCKED = `${ONCHAIN_SERVER}/sdaoLocked`;
export const SUBSCRIBE_ENDPOINT = `${ONCHAIN_SERVER}/home-page-stats/subscribe`;

export const DYNASET_PERFORMANCE_ENDPOINT = `${ONCHAIN_SERVER}/dynasets/price?dynasetSymbol=`;
export const DYNASET_HISTORICAL_PERFORMANCE_ENDPOINT = `${ONCHAIN_SERVER}/dynasets/historical-performance?dynasetSymbol=`;
export const DYNASET_HISTORICAL_PRICE_ENDPOINT = `${ONCHAIN_SERVER}/dynasets/historical-price?dynasetSymbol=`;
export const DYNASET_BLOCKCHAIN_SCRAP_DATA_ENDPOINT =
  process.env.NEXT_PUBLIC_BLOCKCHAIN_DYNASET_SERVICE_URL ||
  `https://bajarfvbp4.execute-api.us-east-1.amazonaws.com/dev/`;

export const DASHBOARD_PNL_ENDPOINT =
  process.env.NEXT_PUBLIC_DASHBOARD_PNL_ENDPOINT ||
  `https://subgraph.dev.singularitydao.ai/pnl`;

export const DYNALABS_ENDPOINT = `${ONCHAIN_SERVER}/dynalab`;
export const DYNALABS_TRADES_ENDPOINT = `${ONCHAIN_SERVER}/dynalab/getTrades`;
export const DYNALABS_HISTORY_ENDPOINT = `${ONCHAIN_SERVER}/dynalab/getHistory`;

export const COIN_GECKO_API_SERVICE = `https://api.coingecko.com/api/v3/`;

export const API_WHITE_LIST_PREFIX = '/dev/launchpad';
export const API_WHITE_LIST_BASE_URL =
  process.env.NEXT_PUBLIC_WHITELIST_API_HOST + API_WHITE_LIST_PREFIX;

export enum DEFAULT_NODE_ENV {
  NONE = 'none',
  PRODUCTION = 'production',
  DEVELOPMENT = 'development',
  PILOT = 'pilot',
}

export enum SORT_ORDER {
  ASC = 'asc',
  DESC = 'desc',
}

export enum POLL_INTERVAL {
  NO_POLLING = 0,
  TEN_SECONDS = 10000,
  ONE_MINUTE = 60000,
  FIFTEEN_MINUTES = 900000,
  THIRTY_MINUTE = 1800000,
}
